import React, { useEffect, useState } from 'react'
import { api } from '../../../app/Api/ApiSlice'
import { Link, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import Loader from '../../../components/Loader'
import { FaPen, FaPlus, FaTimes } from 'react-icons/fa'
import "../storesStyles.css"
import InfiniteScroll from 'react-infinite-scroll-component'
import AdminProductCard from '../../../components/AdminProductCard'


const AdminProducts = () => {
    const [products, setProducts] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [modalOpen, setModalOpen] = useState(false)
    const [page, setPage] = useState(1)
    const [hasMore,setHasMore] = useState(true)

    const [selectedProduct, setSelectedProduct] = useState(null)
    const [saving, setSaving] = useState(false)

    const { name } = useParams()

    useEffect(() => {
        const getProducts = async () => {
            try {
                setIsLoading(true)
                const response = await api.get(`/stores/${name}/manage/products`, { params: { page } })
                if (response) {
                    setProducts(response.data)
                    setHasMore(response.data.length ===20)
                }
            } catch (error) {
                toast.error(error.response.data.message)
                console.log(error)
            }
            finally {
                setIsLoading(false)
            }
        }

        getProducts()
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault()

        const updatedProduct = {
            id: selectedProduct._id,
        }
        try {
            setSaving(true)
            const response = await api.post(`stores/${name}/manage/products/${updatedProduct._id}`, { updatedProduct })
            if (response) {
                setProducts((prev) => [...prev, response.data])
                toast.success("product updated")
                setModalOpen(false)
            }
        } catch (error) {
            toast.error(error.response.data.message)
        }
        finally {
            setSaving(false)
        }
    }

    const handleRefresh = () => { }
    return (
        <div className='shelves-container'>
            <div className={modalOpen ? "modal-open" : "modal-close"}>
                <div className="modal-close-btn">
                    <FaTimes onClick={() => setModalOpen(false)} />
                </div>
                <div className="modal-create-form">
                    <form onSubmit={handleSubmit}>
                        <h3 className="modal-title">Create New Product</h3>
                        <label htmlFor="name">Name</label>
                        <input
                            type="text"
                            required={true}
                            placeholder='products shelf name'
                        // onChange={(e) => setShelfName(e.target.value)}
                        />
                        <label htmlFor="description">Description</label>
                        <input
                            type="text"
                            required={true}
                            placeholder='Shelf description'
                        // onChange={(e) => setShelfDescription(e.target.value)}
                        />
                        <button>{saving ? "Loading..." : "Save"}</button>
                    </form>
                </div>
            </div>
            <div className="shelves-header">
                <h2>{name}</h2>
                <div className='header-add-btn'>
                    <Link to={`/b/manage/${name}/products/new`}>
                        <FaPlus />
                    </Link>
                </div>
            </div>
                <p>Products</p>

            {!isLoading && products.length === 0 && <p className='not-found-msg'>No products in this store</p>}
            <InfiniteScroll
                dataLength={products.length}
                next={() => setPage((prev) => prev + 1)}
                hasMore={hasMore} 
                refreshFunction={handleRefresh}
                loader={<Loader />}
                pullDownToRefresh={true}
            >
                <div className="admin-products-wrapper">
                {
                    products.map((p) => (
                        <AdminProductCard key={p._id} product={p} />
                    ))
                }
                </div>
            </InfiniteScroll>

        </div>
    )
}

export default AdminProducts